import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import CircularProgressBar from './CircularProgressBar'
import js from '../assets/img/js.gif'
import html5 from '../assets/img/html5.gif'
import css from '../assets/img/css.gif'

import nodejs from '../assets/img/nodejs.gif'
import express from '../assets/img/express.svg'
import sequelize from '../assets/img/sequelize.gif'
import postgresql from '../assets/img/postgresql.svg'

import reactjs from '../assets/img/react.gif'
import reduxjs from '../assets/img/redux.svg'
import bootstraplogo from '../assets/img/bootstrap.svg'
import jwt from '../assets/img/jwt-3.svg'
import gitflow from '../assets/img/git.gif'
import scrum from '../assets/img/scrum-1.svg'
import wordpress from '../assets/img/wp.gif'
import elementor from '../assets/img/elementor.gif'
import woocommerce from '../assets/img/woocommerce.gif'
import cpanel from '../assets/img/cpanel.gif'
import adobe from '../assets/img/Adobe.gif'

import kali from '../assets/img/kali.png'
import nmap from '../assets/img/nmap.svg'
import owasp from '../assets/img/owasp.png'
import wireshark from '../assets/img/wireshark.png'
import opencode from '../assets/img/opencode.svg'
import opendesign from '../assets/img/opendesign-logo-lockup.svg'
import { useTranslation } from 'react-i18next';
import useScrollReveal from '../hooks/useScrollReveal';

function Skills() {
    const { t } = useTranslation();
    const sectionRef = useScrollReveal();
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            item: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    return (
        <section className="skill" id="skills" ref={sectionRef}>
            <Container>
                <Row>
                    <Col>
                        <div className="skill-bx">
                            <h2>
                                {t('skills.title')}
                            </h2>
                            <p> {t('skills.description')}</p>
                            <Carousel responsive={responsive} infinite={true} className="skill-slider">
                                <div className="item">
                                    <div className="icon-box">
                                        <CircularProgressBar percentage={95} />
                                    </div>
                                    <h5>{t('skills.be')}</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <CircularProgressBar percentage={92} />
                                    </div>
                                    <h5>{t('skills.fe')}</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <CircularProgressBar percentage={87} />
                                    </div>
                                    <h5>{t('skills.eh')}</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="jspic" src={js} alt="JavaScript" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Javascript</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="htmlpic" src={html5} alt="HTML5" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>HTML5</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="csspic" src={css} alt="CSS" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>CSS</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="nodepic" src={nodejs} alt="Node.js" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>NodeJS</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="sequelizepic" src={sequelize} alt="Sequelize ORM" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Sequelize ORM</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="expresspic" src={express} alt="Express.js" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Express JS</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="postgresqlpic" src={postgresql} alt="PostgreSQL" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>PostgreSQL</h5>
                                </div>

                                <div className="item">
                                    <div className="icon-box">
                                        <img className="reactpic" src={reactjs} alt="React" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>ReactJS</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="reduxpic" src={reduxjs} alt="Redux" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Redux</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="bootstrappic" src={bootstraplogo} alt="Bootstrap" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Bootstrap 5</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="jwtpic" src={jwt} alt="JWT" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Jason Web Token</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="gitpic" src={gitflow} alt="Git" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Git-Flow</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="scrumpic" src={scrum} alt="Scrum" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Scrum</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="kalipic" src={kali} alt="Kali Linux" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Kali Linux</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="owasppic" src={owasp} alt="OWASP" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>OWASP</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="nmappic" src={nmap} alt="Nmap" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Nmap</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="wiresharkpic" src={wireshark} alt="Wireshark" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Wireshark</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="wppic" src={wordpress} alt="WordPress" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>WordPress</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="elementorpic" src={elementor} alt="Elementor" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Elementor</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="woocommercepic" src={woocommerce} alt="WooCommerce" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>WooCommerce</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="cpanelpic" src={cpanel} alt="cPanel" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>cPanel</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="vscode-pic" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg" alt="Visual Studio Code" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Visual Studio Code</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="opencode-icon" src={opencode} alt="OpenCode AI Agent" width="40" height="40" loading="lazy" />
                                    </div>
                                    <h5>AI Agents (OpenCode/Claude/Gemini)</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="opendesign-icon" src={opendesign} alt="Open Design AI Agent" width="40" height="40" loading="lazy" />
                                    </div>
                                    <h5>Open Design AI Agent</h5>
                                </div>
                                <div className="item">
                                    <div className="icon-box">
                                        <img className="adobepic" src={adobe} alt="Adobe Experience Manager" width="60" height="60" loading="lazy" />
                                    </div>
                                    <h5>Adobe Experience Manager</h5>
                                </div>
                            </Carousel>
                            <br /><br />
                            <p>{t('skills.p2')}</p>
                            <p>{t('skills.p3')}</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Skills